var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-3",attrs:{"color":"primary","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.reindex}},[_vm._v(" Re-index ")])
}
var staticRenderFns = []

export { render, staticRenderFns }